import React from 'react';
import { ClickableCard, type ClickableCardProps } from '@wix/design-system';
import style from './surface-aware-clickable-card.module.scss';

export interface SurfaceAwareClickableCardProps
  extends Omit<ClickableCardProps<'a'>, 'as' | 'skin'> {
  containerClassName?: string;
  containerDataHook?: string;
  showShell?: boolean;
}

export function SurfaceAwareClickableCard({
  containerClassName,
  containerDataHook,
  showShell = true,
  href,
  onClick,
  className,
  children,
  ...cardProps
}: SurfaceAwareClickableCardProps) {
  // `className` is applied to our container, never forwarded to ClickableCard:
  // ClickableCard spreads leftover props onto its clickable overlay after its
  // own className, so a forwarded className would replace the overlay's
  // position:absolute class and drop it back into flow.
  return (
    <div
      className={`${showShell ? style.withShell : ''} ${
        containerClassName ?? ''
      } ${className ?? ''}`}
      data-hook={containerDataHook}
    >
      <ClickableCard
        {...cardProps}
        {...(href ? { href } : {})}
        as={href ? 'a' : 'button'}
        onClick={onClick}
        skin={showShell ? 'outline' : 'standard'}
      >
        {children}
      </ClickableCard>
    </div>
  );
}
